import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/LoginPage.css';
//import Promise from 'promise-polyfill';
import AuthService from '../utils/AuthService.js';
import AppointmentService from '../utils/AppointmentService.js';
import CreateAccount from './CreateAccount.js';
import { Switch, Route, Link } from 'react-router-dom'
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Snackbar from '@material-ui/core/Snackbar';

// if (!window.Promise) {
//   window.Promise = Promise;
// }

class ErrorSnackBar extends Component {

  constructor(props) {
    super(props)
    this.state ={
      open: this.props.open
    }
  }
  componentWillReceiveProps(nextProps) {
  // You don't have to do this check first, but it can help prevent an unneeded render
    this.setState({ open: nextProps.open });
}
  handleClose = (event, reason) => {
    //this.props.setOpenToFalse()
    if(this.props.onSnackClosed)
    {
      this.props.onSnackClosed();
    }
    this.setState({ open: false });
  };

    render(){
      return (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.open}
          autoHideDuration={9000}
          onClose={this.handleClose}
          disableWindowBlurListener = {true}
        >
          <SnackbarContent
            style={{backgroundColor: this.props.color}}
            onClose={this.handleClose}
            variant="error"
            message={this.props.message}
        />
        </Snackbar>
              )
    }
}
export default ErrorSnackBar;



// WEBPACK FOOTER //
// ./src/Components/ErrorSnackBar.js